<template>
  <Cms :pageTitle="'Conteúdo da Página de Empresas'" :pageName="'companies'"></Cms>
</template>
<script>
import Cms from '@/pages/cms/Cms'
export default {
  name: 'CompaniesCms',
  components: { Cms }
}
</script>



// WEBPACK FOOTER //
// CompaniesCms.vue?0a215c85